import { __decorate, __metadata } from "tslib";
import { IsBoolean, Length } from 'class-validator';
/**
 * Whether to show the judges and appearances fields in the transcript order form
 */
export class JudgesAndAppearancesConfiguration {
    /**
     * @param showJudges whether to display the judges section on the transcript order form
     * @param showAppearances whether to display the appearances section on the transcript order form
     * @param appearancesDescription the description to display when displaying the appearances section on the
     * transcript order form
     */
    constructor(showJudges, showAppearances, appearancesDescription) {
        this.showJudges = showJudges;
        this.showAppearances = showAppearances;
        this.appearancesDescription = appearancesDescription;
    }
}
JudgesAndAppearancesConfiguration.MAX_DESCRIPTION_LENGTH = 500;
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], JudgesAndAppearancesConfiguration.prototype, "showJudges", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], JudgesAndAppearancesConfiguration.prototype, "showAppearances", void 0);
__decorate([
    Length(0, JudgesAndAppearancesConfiguration.MAX_DESCRIPTION_LENGTH),
    __metadata("design:type", String)
], JudgesAndAppearancesConfiguration.prototype, "appearancesDescription", void 0);
export const DEFAULT_JUDGES_AND_APPEARANCES_CONFIGURATION = new JudgesAndAppearancesConfiguration(false, false, 'Please specify the parties and appearances that were present. This helps our transcribers to produce a more accurate transcript.');
